export default "__VITE_ASSET__d9ed4722__"